module.exports = __webpack_public_path__ + "img/top.58be2c94.png";